import type { Color } from "../../types";
import type { HasAverageColor } from "../HasAverageColor";
import type { HasBackgroundColor } from "../HasBackgroundColor";
import type { VirtualViewportPixelAccessor } from "../VirtualViewportPixelAccessor";
import { AbstractVirtualPixelDecorator } from "./AbstractVirtualPixelDecorator";

/**
 * Background virtual tile decorator.
 */
export class BackgroundVirtualPixel<
  DecoratedType extends VirtualViewportPixelAccessor &
    HasAverageColor &
    HasBackgroundColor
> extends AbstractVirtualPixelDecorator<DecoratedType> {
  /**
   * @inheritDoc
   */
  getVirtualPixelColor(): Color {
    return this.decorated.getBackgroundColor();
  }
}
